import React from 'react';
import {capitalize} from "../../../../../../Utils";

const Head = ({ onSortChange, params, paramNames }) => {
    let th = params.map(param => <th onClick={() => onSortChange(param)} key={param} style={{ position: 'sticky', background: 'whitesmoke', border: '1px solid #ddd', top: 0 }}>{paramNames[param] || capitalize(param)}</th>);

    return (
        <thead>
            <tr>{th}</tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/components/StatsTable/components/Table/components/Head/index.js